export default "__VITE_ASSET__DznVDv9e__"